namespace GeniuzPOS.ReportMasterData {
    export interface Report_1103Row {
        PluCode?: string;
        PluDesc?: string;
        SkuCode?: string;
        SellUnit?: string;
        SupplierId?: string;
        SupplName?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        SellUnitPrice1?: number;
        SellUnitPrice2?: number;
        SellUnitPrice3?: number;
        SellUnitPrice4?: number;
        SellUnitPrice5?: number;
        SellUnitPrice6?: number;
        CostPrice?: number;
        VatType?: string;
        VatCode?: string;
    }

    export namespace Report_1103Row {
        export const idProperty = 'PluCode';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'ReportMasterData.Report_1103';
        export const deletePermission = '1POSBASE:รายงาน:ทะเบียน:ราคาสินค้าเทียบราคาทุน:View';
        export const insertPermission = '1POSBASE:รายงาน:ทะเบียน:ราคาสินค้าเทียบราคาทุน:View';
        export const readPermission = '1POSBASE:รายงาน:ทะเบียน:ราคาสินค้าเทียบราคาทุน:View';
        export const updatePermission = '1POSBASE:รายงาน:ทะเบียน:ราคาสินค้าเทียบราคาทุน:View';

        export declare const enum Fields {
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            SkuCode = "SkuCode",
            SellUnit = "SellUnit",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            SellUnitPrice1 = "SellUnitPrice1",
            SellUnitPrice2 = "SellUnitPrice2",
            SellUnitPrice3 = "SellUnitPrice3",
            SellUnitPrice4 = "SellUnitPrice4",
            SellUnitPrice5 = "SellUnitPrice5",
            SellUnitPrice6 = "SellUnitPrice6",
            CostPrice = "CostPrice",
            VatType = "VatType",
            VatCode = "VatCode"
        }
    }
}
